import { Col, Container, Row } from "react-bootstrap";
// import NotFound from "../../components/notfound";
// import SkillsListItem from "./skills-list-item";
import { useNavigate } from "react-router-dom";
import CSSTransitionWrapper from "../../components/hooks/useCssTransition";
import useCheckInViewById from "../../components/hooks/useCheckInViewById";
import { AnimationTypes } from "../../components/hooks/useCssTransition";
import SVGIcon from "../../components/svg-icons/svg-icons";
import { FaMobileAlt, FaSass } from "react-icons/fa";
import { ImMobile } from "react-icons/im";
import { BsArrowRight, BsRecycle } from "react-icons/bs";
import { BiRecycle } from "react-icons/bi";
import SkillListItem from "./skills-list-item";
type Props = {
  onClickHandler: (id: number, e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEventHandler: (item: string, e: React.MouseEvent<HTMLElement>) => void;
  data: any;
};
const SkillsList = (props: Props) => {
  let navigate = useNavigate();
  /****** EVENT HANDLING ******/
  /* PASS ON TO PARENT HOC FOR LOGIC */
  // const onMouseEventHandler = (
  //   item: string,
  //   e: React.MouseEvent<HTMLElement>
  // ) => {
  //   props.onMouseEventHandler(item, e);
  // };

  // const onClickHandler = (
  //   item: number,
  //   e: React.MouseEvent<HTMLButtonElement>
  // ) => {
  //   props.onClickHandler(item, e);
  // };

  /****** COMPONENT RENDERING *****/
  // let SkillsJSX: JSX.Element[] | JSX.Element = (
  //   <NotFound text="No Skills List Found" />
  // );

  // if (props.data.length > 0) {
  //   SkillsJSX = props.data.map((item: any, index: number) => {
  //     return (
  //       <SkillsListItem
  //         itemID={item.id}
  //         key={index}
  //         image={item.image}
  //         title={item.title}
  //         description={item.description}
  //         message={item.message}
  //         svgIcon={item.svgIcon}
  //         onMouseEventHandler={onMouseEventHandler.bind(null, item.message)}
  //         onClickHandler={onClickHandler.bind(null, item.id)}
  //       />
  //     );
  //   });
  // }

  const onClickSetHistory = () => {
    navigate("/reactjs/usestate");
    // history.push('reactjs/usestate')
  };

  // const onClickGoStore = () => {
  //   navigate("/reactjs/usestate");
  //   // history.push('reactjs/usestate')
  // };
  const isSkillHeadingInView = useCheckInViewById("skill_heading");

  const isReactInView = useCheckInViewById("skill_react");

  return (
    <section
      id="SkillsSection"
      className="container-fluid pt-5 pb-5 z-3 bg-1 before"
    >
      <Container id="skill_heading" style={{ minHeight: "20vh" }}>
        <Row className="mb-5 z-2 pt-5">
          <Col>
            <CSSTransitionWrapper
              in={isSkillHeadingInView}
              delay={200}
              animation={AnimationTypes.FLIPINX}
            >
              <h2 className="color_filled text__center text__uppercase font__h1">
                Front End Development
              </h2>
            </CSSTransitionWrapper>
            <CSSTransitionWrapper
              in={isSkillHeadingInView}
              delay={400}
              animation={AnimationTypes.FADEINUP}
            >
              <h4 className="color_filled text__center">
                My real world experiences below
              </h4>
            </CSSTransitionWrapper>
            <CSSTransitionWrapper
              in={isSkillHeadingInView}
              delay={600}
              animation={AnimationTypes.FADEINUP}
            >
              <p className="text-center color_1">
                You might find something useful here, best practices and some
                use case approaches.
              </p>
            </CSSTransitionWrapper>
          </Col>
        </Row>
      </Container>
      <Container className="pt-5">
        <Row>
          <SkillListItem
            title="React JS"
            content="A JavaScript library for building user interfaces, incredibly
            fast, and promotes declarative javascript coding and build
            encapsulated components."
            icon="REACT"
            id="skills_react"
          />
          <SkillListItem
            title="Typescript"
            content="Eliminate potential bugs in development by precisely defining
            type annotations, securing strongly type action guards or
            defining a strict event handlers."
            icon="TYPESCRIPT"
            id="skills_ts"
          />
          <SkillListItem
            title="Modern JS"
            content="Technology is constantly evolving, so thus JavaScript. New
            standardized version of JavaScript introduces us a lot of
            features that are a response to best practices and ease of
            use."
            icon="JS"
            id="skills_js"
          />
          <SkillListItem
            title="CSS3 + Preprocessors"
            content="We facilitate ourselves to write clean, easy and less CSS in a
            programming construct and gives us the capability to extend
            complex styles without writing heavy line of codes."
            icon="SASS"
            id="skills_css"
            viewBox={32}
          />
          <SkillListItem
            title="Mobile First Design"
            content="Mobile-first design is a key ingredient to successful
            product design, it promotes accessibility on any platforms
            our customers use and bringing in more conversions."
            icon="MOBILE"
            id="skills_mobile"
          />
          <SkillListItem
            title="Reusable Components"
            content="  We promote consistency across the ecosystem and we make sure
            that user-experience will be same across all the products.
            Easy to maintain, can be used multiple times within the
            application."
            icon="REUSE"
            id="skills_reuse"
          />

          {/* <Col xs={12} sm={6} md={4} className="pv__gutter">
            <div className="card2 shadow__thin">
              <div className="card2__content">
                <span id="skill_reusable">
                  <CSSTransitionWrapper
                    in={isReusableInView}
                    delay={200}
                    animation={AnimationTypes.BACKINRIGHT}
                  >
                    <SVGIcon icon="REUSE" />
                  </CSSTransitionWrapper>
                </span>
                <h3 className="mt-3 color_2">Reusable Components</h3>
                <p className="color_1">
                
                </p>
              </div>
            </div>
          </Col> */}
        </Row>
      </Container>
      <Container>
        <Row className="pt-5 pb-5">
          <Col md={6} className="mt-3 mb-3">
            <a
              href="http://store.ngsilvestre.com"
              target="_blank"
              className="button button__rounded button__lg d-block color__primary"
              rel="noreferrer"
            >
              <span>
                <BsArrowRight size={"2em"} />
                See sample online store
              </span>
            </a>
          </Col>
          <Col md={6} className="mt-3 mb-3">
            <button
              className="button button__rounded button__lg d-block color__primary"
              onClick={onClickSetHistory}
            >
              <span>
                <BsArrowRight size={"2em"} /> View ReactJS Skills Processes
              </span>
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SkillsList;
